import React from 'react';

import { di } from 'react-magnetic-di';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditScaleInput } from './edit';
import { PreviewScaleInput } from './preview';
import { ViewScaleInput } from './view';

export const ScaleInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	if (!fg('phx-3346_proforma_rating_question_type')) {
		return <></>;
	}

	if (renderMode === FormRenderMode.EDIT) {
		return (
			<EditScaleInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	if (renderMode === FormRenderMode.PREVIEW) {
		return (
			<PreviewScaleInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	return (
		<ViewScaleInput
			fieldId={fieldId}
			fieldInputId={fieldInputId}
			fieldLabelId={fieldLabelId}
			fieldErrorId={fieldErrorId}
		/>
	);
};
